export { default } from "./src/side-nav-collection";

export type { UniformSideNavCollectionProps } from "./src/side-nav-collection";
